import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private profileCompletedSubject = new BehaviorSubject<boolean>(false);
  public profileCompleted$: Observable<boolean> = this.profileCompletedSubject.asObservable();

  constructor(private router: Router, private alertController: AlertController) {}

  setProfileCompleted(isCompleted: boolean) {
    console.log('[AUTH SERVICE] Setting profileCompleted to:', isCompleted);
    this.profileCompletedSubject.next(isCompleted);
  }

  getProfileCompleted(): boolean {
    return this.profileCompletedSubject.value;
  }

  async signOut() {
    // TODO: Implement real sign out logic (e.g., clear tokens, call backend)
    const alert = await this.alertController.create({
      header: 'Signed out',
      message: 'You have been signed out.',
      buttons: ['OK']
    });
    await alert.present();
    this.router.navigate(['']);
  }
}
